import { styled } from '@mui/material';

export const FormContainer = styled('form', {
  shouldForwardProp: prop => prop !== '$isMobileOrTablet',
})(({ $isMobileOrTablet }: { $isMobileOrTablet: boolean }) => ({
  padding: $isMobileOrTablet ? '0' : '0 100px',
  marginTop: $isMobileOrTablet ? '52px' : '24px',
  justifySelf: 'center',
  minWidth: $isMobileOrTablet ? '100%' : '557px',
  maxWidth: '757px',
  width: '100%',
  boxSizing: 'border-box',
}));
